import { useContext, useEffect, useMemo } from 'react';

import classnames from 'classnames';

import { MainContext, SYSTEM_EVENTS } from '@ezbobdev/ui-framework';

export const usePage = (props) => {
  const { className, pageName, location, appUsesSteps = true } = props;
  const { actions, userState } = useContext(MainContext);
  const route = actions.settings.getPageRoute(pageName);
  const pageDetails = actions.userState.getPageDetails(pageName);
  const stepName = appUsesSteps ? actions.userState.getCurrentStepDetails().stepName : null;

  const setPage = () => {
    actions.settings.setPageRoute(route, pageName);
    window.scroll({ top: 0, behavior: 'smooth' });
  };

  const wrapperClasses = useMemo(
    () => classnames(`Page`, pageName && `page-${pageName}`, stepName && `step-${stepName}`, className),
    [pageName, stepName, className],
  );

  useEffect(() => {
    setPage();
    actions.events.emit(SYSTEM_EVENTS.PAGE_DID_MOUNT, { pageName });
    typeof props.didMount === 'function' && props.didMount(pageDetails);
  }, [location]);

  useEffect(() => {
    actions.view.clearAlerts({ ignoreType: 'info' });
  }, []);

  return { stepName, userState, wrapperClasses, setPage };
};
